import { render } from "./SendFeedbackForm.vue?vue&type=template&id=9d06dfe6&scoped=true"
import script from "./SendFeedbackForm.vue?vue&type=script&lang=js"
export * from "./SendFeedbackForm.vue?vue&type=script&lang=js"

import "./SendFeedbackForm.vue?vue&type=style&index=0&id=9d06dfe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d06dfe6"]])

export default __exports__